import moment from 'moment';
import Budget from "./Budget.jsx";
import DateHelper from "../utilities/DateHelper.js";

export default class AdHocLoan {
	static counts = 1;
	principal = '';
	interest = '';
	minimumPayment = '';
	monthlyPayment = '';
	name = '';
	escrowAndFeesPerMonth = '';
	mortgageInsurance = '';
	mortgageInsuranceUntil = '';

	constructor() {
		this.id = AdHocLoan.counts++;
		this.startDate = moment();
		this.budget = new Budget();
		this.budgets = {};

		// this.principal = 50000 * 100;
		// this.interest = 2.5;
		// this.minimumPayment = 1000 * 100;
		// this.name = 'Testz';
	}

	isEmpty() {
		return !this.principal &&
			!this.interest &&
			!this.minimumPayment &&
			!this.monthlyPayment &&
			!this.name &&
			!this.escrowAndFeesPerMonth;
	}

	fullName() {
		return this.name;
	}

	getBudget(selectedDate) {
		if(!selectedDate) {
			throw new Error('need to know which budget to retrieve!');
		}
		const budgetKey = DateHelper.yearMonthSerialize(selectedDate);
		if(DateHelper.yearMonthSerialize(this.budget.date) === budgetKey) {
			return this.budget;
		}
		else {
			return this.budgets[budgetKey] = Budget.create({
				year: selectedDate.year(),
				month: selectedDate.month() + 1,
				category: this,
			});
		}
	}

	getBudgetsInOrder() {
		const budget = this.budget;
		budget.update({
			category: this,
			fund_total: this.principal * 100,
			date: this.startDate,
			interest_amount: this.interest,
			minimum_payment: (this.monthlyPayment || this.minimumPayment) * 100,
		});
		return [budget];
	}

	getAmountPaidPerMonth() {
		let base = this.monthlyPayment || this.minimumPayment;
		if(!base) {
			base = 0;
		}
		base = Number.parseFloat(base);
		if(!this.escrowAndFeesPerMonth) {
			return base;
		}
		if(!Number.parseFloat(this.escrowAndFeesPerMonth)) {
			return base;
		}
		const escrow = Number.parseFloat(this.escrowAndFeesPerMonth);
		return base + escrow;
	}

	totalMonthlyPayment() {
		return this.monthlyPayment;
	}

	serialize() {
		const data = {};
		data.principal = this.principal;
		data.interest = this.interest;
		data.minimumPayment = this.minimumPayment;
		data.monthlyPayment = this.monthlyPayment;
		data.escrowAndFeesPerMonth = this.escrowAndFeesPerMonth;
		data.name = this.name;
		data.disabled = this.disabled;
		return data;
	}

	static unserialize(data) {
		const loan = new AdHocLoan();
		loan.principal = data.principal;
		loan.interest = data.interest;
		loan.minimumPayment = data.minimumPayment;
		loan.monthlyPayment = data.monthlyPayment;
		loan.escrowAndFeesPerMonth = data.escrowAndFeesPerMonth;
		loan.name = data.name;
		loan.disabled = data.disabled;
		return loan;
	}
}
